import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "@fontsource-variable/inter";

// Redirect bare domain → www before any React/Clerk code runs.
// This is critical for SSO callbacks: Google OAuth redirects back via
// skoltend.com/sign-in/sso-callback, but Clerk-Proxy-Url is www.skoltend.com,
// causing "failed security validations". The redirect preserves the full URL
// (including OAuth state/code query params) so Clerk can process it correctly.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

if (
  typeof window !== "undefined" &&
  window.location.hostname === "skoltend.com"
) {
  const wwwUrl =
    "https://www.skoltend.com" +
    window.location.pathname +
    window.location.search +
    window.location.hash;
  window.location.replace(wwwUrl);
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
